import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ROUTES } from '../../../constants';
import { getPage } from '../../../reducers/returns';
import { fetchOrderDetails } from '../../../actions';
import { handleBackClick } from '../../../actions/onlineReturns';
import { getIsUserLoggedIn } from '../../../utils/cookie';
import { safelyAccessNestedProperties } from '../../../utils';
import { fetchOrderHistoryOrderDetails } from '../../../actions/orderHistory';

type Props = {
  page: string,
  goBacktoEligibility: Function,
  isAuth?: Boolean,
  onFetchOrderDetails: Function,
  onFetchOrderHistoryOrderDetails: Function,
  history: Object,
};

class ReturnsMobileLinks extends Component<Props> {
  handleBackToOnlineOrders = () => {
    const {
      onFetchOrderDetails,
      history,
      onFetchOrderHistoryOrderDetails,
    } = this.props;
    const isAuth = getIsUserLoggedIn();
    const orderId = safelyAccessNestedProperties(
      ['location', 'state', 'orderId'],
      history
    );
    if (isAuth) {
      onFetchOrderHistoryOrderDetails(orderId);
      return history.push(ROUTES.PATH.ORDER_HISTORY);
    }
    return onFetchOrderDetails(history);
  };

  handleBackClick = () => {
    const { history, isAuth } = this.props;
    const pathname = isAuth
      ? ROUTES.PATH.ORDER_HISTORY
      : ROUTES.PATH.ONLINE_ORDER;
    history.push(pathname);
  };

  render() {
    const { page, goBacktoEligibility, isAuth } = this.props;
    const message = `Return to Order ${isAuth ? 'History' : 'Details'}`;

    return (
      <React.Fragment>
        {(page === 'landing' || page === 'error') && (
          <div data-automation-id="landing-cancel-link">
            <button
              type="button"
              className="u__default-link"
              onClick={this.handleBackClick}
            >
              <span className="u__text--alternate mw-icon-back-symbol" />
              {message}
            </button>
          </div>
        )}
        {page === 'hrtv' && (
          <div data-automation-id="nextSteps-back-button">
            <button
              type="button"
              className="u__default-link"
              onClick={goBacktoEligibility}
            >
              <span className="u__text--alternate mw-icon-back-symbol" />
              Back
            </button>
          </div>
        )}
        {page === 'ssrCreate' && (
          <div data-automation-id="mobile-backToOrderDetails-button">
            <button
              type="button"
              className="u__default-link"
              onClick={this.handleBackToOnlineOrders}
            >
              <span className="u__text--alternate mw-icon-back-symbol" />
              {message}
            </button>
          </div>
        )}
      </React.Fragment>
    );
  }
}

ReturnsMobileLinks.defaultProps = {
  isAuth: false,
};

const mapStateToProps = (state: Object) => ({
  page: getPage(state),
});

const mapDispatchToProps = {
  goBacktoEligibility: handleBackClick,
  onFetchOrderDetails: fetchOrderDetails,
  onFetchOrderHistoryOrderDetails: fetchOrderHistoryOrderDetails,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReturnsMobileLinks)
);
